import { useMutation, useQuery } from '@tanstack/react-query';

import {
  AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest,
  AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest,
  useApi,
} from '@sbv-clients/data-access-api';
import { UnwrapArray } from '@sbv-clients/util-misc';

import { AdminCacheKeys } from '../utils/cache-keys';

export const useAdminFacilitiesActiveEmployeesGet = (
  body: AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest,
  config?: { keepPreviousData: boolean }
) => {
  const api = useApi();
  return useQuery({
    queryKey: [AdminCacheKeys.FacilityUsers, body],
    queryFn: () =>
      api.adminFacilityApi
        .adminFacilityFacilityIdActiveEmployeesGet(body)
        .then((response) => response?.data),
    refetchOnWindowFocus: false,
    ...config,
  });
};

export type AdminFacilityEmployeeType = NonNullable<
  UnwrapArray<
    NonNullable<
      ReturnType<typeof useAdminFacilitiesActiveEmployeesGet>['data']
    >['data']
  >
>;

export const useAdminFacilityByDatabaseNameGetWithMutation = () => {
  const api = useApi();
  return useMutation((databaseName: string) => {
    return api.adminFacilityApi
      .adminFacilityConfigurationsDatabaseNameGet({ databaseName })
      .then((response) => response.data);
  });
};

export const useAdminFacilitiesPreProcessOnboardingGet = (
  body: AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest
) => {
  const api = useApi();
  return useQuery({
    queryKey: [AdminCacheKeys.FacilityUsers, body],
    queryFn: () =>
      api.adminFacilityApi
        .adminFacilityPreProcessOnboardingGet(body)
        .then((response) => response?.data),
    refetchOnWindowFocus: false,
  });
};

export type AdminFacilityElasticEmployeeType = NonNullable<
  UnwrapArray<
    NonNullable<
      ReturnType<typeof useAdminFacilitiesPreProcessOnboardingGet>['data']
    >['data']
  >
>;
